import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location: string) {
  return (originalPush.call(this, location) as any).catch((error: Error) => error)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

router.afterEach((route) => {
  const { title, overflowY } = route.meta || {}
  if (title) {
    document.title = title
  }
  setTimeout(() => {
    const contentWrapperEl = document.querySelector('.content-wrapper')as HTMLElement
    if (contentWrapperEl) {
      contentWrapperEl.style.overflowY = overflowY ? 'auto' : 'unset'
    }
  }, 0)
})

export default router
